import { useEffect, useState } from 'react';

const useOutsideClick = ref => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const handleOutsideClick = event => {
    // console.log('useOutsideClick', ref.current?.contains(event.target));
    if (ref.current) {
      setIsDropdownVisible(ref.current?.contains(event.target));
    }
  };

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.addEventListener('click', handleOutsideClick);
    }
    return () => {
      if (typeof document !== 'undefined') {
        document.removeEventListener('click', handleOutsideClick);
      }
    };
  }, [ref]);

  return isDropdownVisible;
};

export default useOutsideClick;
